import { api } from "../Configurations/axios";
import { OpportunitiesPanelsModel } from "../Models/OpportunitiesPanelsModel";

const CreatOpportunitiesPanelsAPI = async (
  companyId: string,
  userEmail: string,
  number: number,
  name: string,
  year: number,
  comments: string
) => {
  try {
    const r = await api.post("/OpportunitiesPanels/CreateOpportunitiesPanels", {
      companyId: companyId,
      userEmail: userEmail,
      number: number,
      name: name,
      year: year,
      comments: comments,
    });
    const resp = await r.data;
    return resp;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const GetAllOpportunitiesPanelsAPI = async (
  companyId: string,
  page: number,
  take: number,
  word: string
) => {
  try {
    word = word === "" ? "all" : word;
    const result = await api.get(
      `/OpportunitiesPanels/GetAllOpportunitiesPanelsByCompanyId/?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(
        word
      )}`
    );
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const GetAllOpportunitiesPanelsByCompanyAPI = async (
  companyId: string
) => {
  try {
    const result = await api.get(`/OpportunitiesPanels/GetAllOpportunitiesPanels?companyId=${companyId}`);
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const GetOpportunitiesPanelsByIdAPI = async (opportunitiesPanelsId: string) => {
  try {
    const result = await api.get(
      `/OpportunitiesPanels/GetOpportunitiesPanel/?opportunitiesPanelsId=${opportunitiesPanelsId}`
    );
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const GetAllProjectLinesByCompanyIdAndYear = async (
  companyId: string,
  year: number
) => {
  try {
    const result = await api.get(
      `/OpportunitiesPanels/GetGrantsLinesByProject/?companyId=${companyId}&year=${year}`
    );
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const GetAllYearsFromProjects = async (companyId: string) => {
  try {
    const result = await api.get(
      `/OpportunitiesPanels/GetAllYearsFromProjects/?companyId=${companyId}`
    );
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const EditOpportunitiesPanelsAPI = async (
  id: string,
  result: number,
  userEmail: string
) => {
  try {
    const r = await api.put("/OpportunitiesPanels/EditOpportunitiesPanels", {
      id: id,
      result: result,
      userEmail: userEmail,
    });
    const response = await r.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const DeleteOpportunitiesPanelsAPI = async (
  opportunitiesPanelsId: string,
  companyId: string
) => {
  try {
    const result = await api.delete(
      "/OpportunitiesPanels/DeleteOpportunitiesPanels",
      {
        data: {
          opportunitiesPanelsId: opportunitiesPanelsId,
          companyId: companyId,
        },
      }
    );
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};
const DownloadGrantsDocumentAPI = async (
  companyId: string,
  panelId: string,
  formatToSave: boolean) => {
  try {
    const result = await api.get(
      `/OpportunitiesPanels/DownloadGrantsDocument?companyId=${companyId}&panelId=${panelId}&formatToSave=${formatToSave}`, {
      responseType: 'blob'
    });
    const response = result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

export {
  GetAllProjectLinesByCompanyIdAndYear,
  GetAllYearsFromProjects,
  CreatOpportunitiesPanelsAPI,
  GetAllOpportunitiesPanelsAPI,
  GetOpportunitiesPanelsByIdAPI,
  EditOpportunitiesPanelsAPI,
  DeleteOpportunitiesPanelsAPI,
  GetAllOpportunitiesPanelsByCompanyAPI,
  DownloadGrantsDocumentAPI
};
